module.exports = __webpack_public_path__ + "dce4b6b7f0f73b12ab9040f871a7144c.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/Lato-Hairline.ttf
// module id = 992
// module chunks = 0